import QueryEmployeeConfidants from 'graphql/queries/QueryEmployeeConfidants'
import GraphqlGroupedBuilder from 'utils/request/graphql/groupedBuilder'

const FetchEmployeeConfidant = {
	
	fetchAll: ( { variables = {}, callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) => {
		GraphqlGroupedBuilder.addQuery( 'employees_confidant', QueryEmployeeConfidants, {
			variables,
			resultPath: [ 'employees_confidant' ],
			callbackStart,
			callbackError,
			callbackSuccess
		})
	}
}

export default FetchEmployeeConfidant
